import { ApplicationStep, Field, PlaidStatus, StepbystepApplicationStep } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

export const insertPlaidSteps = (applicationSteps: ApplicationStep[], plaidStatus?: PlaidStatus): ApplicationStep[] => {
  // Insert the plaid step before the email
  if (!applicationSteps.includes(StepbystepApplicationStep.PlaidConnect)) {
    const emailStepIndex = applicationSteps.indexOf(StepbystepApplicationStep.Email)
    applicationSteps.splice(emailStepIndex, 0, StepbystepApplicationStep.PlaidConnect)
  }

  // Insert the summary after the plaid connect step if the user connected to plaid
  if (plaidStatus !== PlaidStatus.NotConnected && !applicationSteps.includes(StepbystepApplicationStep.PlaidSummary)) {
    const plaidConnectStepIndex = applicationSteps.indexOf(StepbystepApplicationStep.PlaidConnect)
    applicationSteps.splice(plaidConnectStepIndex + 1, 0, StepbystepApplicationStep.PlaidSummary)
  }

  return applicationSteps
}

export const removeStepsPopulatedByPlaid = (
  applicationSteps: ApplicationStep[],
  plaidSummaryFieldsToDisplay: Field[],
): ApplicationStep[] => {
  // Remove fields that are displayed in the Plaid summary card
  plaidSummaryFieldsToDisplay.forEach((field) => {
    switch (field) {
      case Fields.EmailAddress: {
        const index = applicationSteps.indexOf(StepbystepApplicationStep.Email)
        if (index !== -1) {
          applicationSteps.splice(index, 1)
        }
        break
      }
      case Fields.FirstName:
      case Fields.LastName: {
        const index = applicationSteps.indexOf(StepbystepApplicationStep.Name)
        if (index !== -1) {
          applicationSteps.splice(index, 1)
        }
        break
      }
      case Fields.AddressOne:
      case Fields.AddressTwo:
      case Fields.Zipcode:
      case Fields.City:
      case Fields.State: {
        const index = applicationSteps.indexOf(StepbystepApplicationStep.Address)
        if (index !== -1) {
          applicationSteps.splice(index, 1)
        }
        break
      }
      case Fields.PhoneNumber: {
        const index = applicationSteps.indexOf(StepbystepApplicationStep.Phone)
        if (index !== -1) {
          applicationSteps.splice(index, 1)
        }
        break
      }
      case Fields.AnnualIncomeLoan: {
        const index = applicationSteps.indexOf(StepbystepApplicationStep.AnnualIncome)
        if (index !== -1) {
          applicationSteps.splice(index, 1)
        }
        break
      }
      case Fields.PayFrequency: {
        const index = applicationSteps.indexOf(StepbystepApplicationStep.PayFrequency)
        if (index !== -1) {
          applicationSteps.splice(index, 1)
        }
        break
      }
      default:
    }
  })

  return applicationSteps
}
